export enum SenderTypeEnum {
  USER = "USER",
  ASSISTANT = "ASSISTANT",
}
